import { FC, HTMLAttributes, useState } from 'react';
import clx from 'classnames';
import { Row } from 'reactstrap';
import { IFormProps } from '..';
import { FormViewModel } from '../../Models';
import { Headline } from 'src/UI';
import st from './Collapsed.module.scss';

interface ICollapsedProps extends IFormProps, HTMLAttributes<HTMLDivElement> {
	model: FormViewModel;
	defaultOpen?: boolean;
}

const Collapsed: FC<ICollapsedProps> = (props) => {
	const { defaultOpen, children, model } = props;
	const [expand, setExpand] = useState<boolean>(!!defaultOpen);

	const renderContent = () => {
		return <Row hidden={!model.ControlVisibility}>{children}</Row>;
	};

	if (model.ControlKey === 'NormalView' || !model.Parent) {
		return renderContent();
	}

	return (
		<div
			hidden={!model.ControlVisibility}
			className={clx(st.spoilerBlock, { [st.expanded]: expand })}
		>
			<Headline
				className={clx(st.spoilerBtn)}
				onClick={() => {
					return setExpand(!expand);
				}}
			>
				<svg width="32" height="32" viewBox="0 0 18 18" fill="inherit">
					<path
						d="M11.8688 11.25L9 8.38125L6.13125 11.25L5.25 10.3625L9 6.6125L12.75 10.3625L11.8688 11.25Z"
						fill="inherit"
					/>
				</svg>
				{model.Caption}
			</Headline>
			<div className={st.spoilerContent}>{renderContent()}</div>
		</div>
	);
};

export default Collapsed;
